module.exports = __webpack_public_path__ + "fonts/CashSans-BlackItl.52a5be3.woff2";